module.exports = __webpack_public_path__ + "img/blackwidow.354af7c9.svg";